import { render } from "./ShipmentList.vue?vue&type=template&id=6a21729c"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"
script.render = render

export default script